import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

// Layout components
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { MobileFooter } from './components/layout/MobileFooter';
import { BottomNavBar } from './components/layout/BottomNavBar';
import { CartSidebar } from './components/cart/CartSidebar';

// Tracking
import { TrackingProvider } from './components/tracking/TrackingProvider';
import { ConsentBanner } from './components/tracking/ConsentBanner';

// Pages
import { HomePage } from './pages/HomePage';
import { ShopPage } from './pages/ShopPage';
import { ProductPage } from './pages/ProductPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { OrderConfirmationPage } from './pages/OrderConfirmationPage';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <TrackingProvider>
          <div className="flex flex-col min-h-screen">
            {/* Header */}
            <Header />

            {/* Cart Sidebar */}
            <CartSidebar />

            {/* Main Content */}
            <main className="flex-1">
              <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/product/:categorySlug/:productSlug" element={<ProductPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/products" element={<ShopPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmationPage />} />

              {/* 404 - Not Found */}
              <Route
                path="*"
                element={
                  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
                    <h1 className="text-6xl font-display font-bold text-primary-500 mb-4">
                      404
                    </h1>
                    <p className="text-xl text-secondary-900 mb-2">
                      Page non trouvée
                    </p>
                    <p className="text-gray-500 mb-6">
                      La page que vous recherchez n'existe pas.
                    </p>
                    <a href="/" className="btn-primary">
                      Retour à l'accueil
                    </a>
                  </div>
                }
              />
            </Routes>
          </main>

            {/* Footer - Desktop */}
            <Footer />

            {/* Footer - Mobile */}
            <MobileFooter />

            {/* Bottom Navigation - Mobile Only */}
            <BottomNavBar />
          </div>

          {/* Consent Banner */}
          <ConsentBanner />
        </TrackingProvider>

        {/* Toast Notifications */}
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#1A1A1A',
              color: '#fff',
              borderRadius: '12px',
              padding: '12px 16px',
            },
            success: {
              iconTheme: {
                primary: '#10B981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#EF4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
